import { AvailabilityDayOfWeekInterval, AvailabilityTimeOfDayInterval } from '@uplift/api';

export const availabilityTimeOfDayOptions = [
  { value: AvailabilityTimeOfDayInterval.EARLY_MORNING, label: 'Early Morning' },
  { value: AvailabilityTimeOfDayInterval.MORNING, label: 'Morning' },
  { value: AvailabilityTimeOfDayInterval.AFTERNOON, label: 'Afternoon' },
  { value: AvailabilityTimeOfDayInterval.EVENING, label: 'Evening' },
];

export const availabilityDayOfWeekOptions = [
  { value: AvailabilityDayOfWeekInterval.MONDAY, label: 'Monday' },
  { value: AvailabilityDayOfWeekInterval.TUESDAY, label: 'Tuesday' },
  { value: AvailabilityDayOfWeekInterval.WEDNESDAY, label: 'Wednesday' },
  { value: AvailabilityDayOfWeekInterval.THURSDAY, label: 'Thursday' },
  { value: AvailabilityDayOfWeekInterval.FRIDAY, label: 'Friday' },
  { value: AvailabilityDayOfWeekInterval.SATURDAY, label: 'Saturday' },
  { value: AvailabilityDayOfWeekInterval.SUNDAY, label: 'Sunday' },
];
